<style scoped lang="scss" type="text/scss">
    .item-container-wrap {
        height: 5rem;
        width: 14rem;
        min-width: 14rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #F4F4F4;
        padding: 1rem 1.5rem;
        font-size: .85rem;
        border-radius: .15rem;
        box-sizing: border-box;

        &:hover {
            cursor: pointer;

            .operation-panel {
                opacity: 1;

                .delete:hover {
                    color: #FF3333;
                }

                .edit:hover {
                    color: #3E9EFF;
                }
            }
        }

        &:not(:first-child) {
            margin-left: 1rem;
        }

        .operation-panel {
            position: absolute;
            right: .3rem;
            top: .2rem;
            opacity: 0;
            transition: all .2s;
        }

        .prefix-icon {
            font-size: 1.4rem;
            margin-right: .8rem;
        }
    }
</style>

<template>
    <border-active-block class="item-container-wrap global-relative" :active="active">
        <span class="operation-panel" v-if="hasAdminEditablePermission">
            <i class="icon edit" @click="callEdit">&#xe65c;</i>
            <i class="icon delete" @click="callRemove">&#xe61e;</i>
        </span>
        <i class="icon prefix-icon">&#xe633;</i>
        <slot></slot>
        <loading-placeholder loading-text="操作中..." :loading="operating"></loading-placeholder>
    </border-active-block>
</template>

<script>
    import BorderActiveBlock from '../../../../../../components/border-active-block/index';

    export default {
        name: '',
        props: {
            active: {
                type: Boolean,
                default: false
            }
        },
        components: {
            BorderActiveBlock
        },
        data () {
            return {
                operating: false
            };
        },
        computed: {
            hasAdminEditablePermission () {
                return this.$store.getters['user/hasAdminEditablePermission'];
            }
        },
        methods: {
            callback () {
                this.operating = false;
            },
            callEdit () {
                this.$emit('call-edit', this.callback);
            },
            callRemove () {
                this.operating = true;
                this.$emit('call-remove', this.callback);
            }
        }
    };
</script>
